<template>
  <button-custom :action="goToAnswer" padding="s">
    {{ $l.goToAnswerSheet }}
  </button-custom>
</template>

<script>
import ButtonCustom from '@/components/Button'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonCustom
  },

  methods: {
    goToAnswer: function () {
      this.$router.push({ name: 'answer-sheet' })
      this.$store.dispatch('popupQuiz/hide', null)
    }
  }
}
</script>

